module.exports = __webpack_public_path__ + "static/KAIZEN_01-1299ad89606dbba2770b74285df41c90.jpg";